<template>
  <div class="file">
    <Button type="primary" v-if="showOperate && !fileManager" class="mb-10" icon="ios-cloud-upload-outline" @click="showUploadModel(-1,-1,-1)" size="small">
      {{buttonText}}</Button>
    <Table v-if="!table.refreshTable && fileData.length > 0" class="mb-10" stripe :columns="table.columns" :data="fileData" border></Table>

    <wsModal v-model="upload.show" title="文件上传" ok-text="上传" :whetherShowOk='false' @on-ok="okUploadModel()" @on-cancel='cancelModel()'>
      <Form ref="uploadModelForm" :model="upload.form" :rules="upload.validate" :label-width="70" class="depart_form">
          <Alert type="warning">如无法选择类别，请刷新浏览器后重试。</Alert>
          <FormItem label="类别" prop="typeArray">
             <Cascader :data="fields.typeArrays" :disabled="upload.editIndex != -1" v-model="upload.form.typeArray" @on-change="typeArraysChange"></Cascader>
          </FormItem>
          <FormItem label="附注" prop="attachRemark" >
            <Input v-model="upload.form.attachRemark" />
          </FormItem>
          <FormItem label="上传附件" prop="file" >
            <Upload style="width:105px;" :accept='upload.accept' :format='upload.uploadformat' :action="upDownPic +fileName" :show-upload-list='false' type="drag" :on-exceeded-size='exceededSize' :on-format-error="formatError" :before-upload="handleUpload" :on-error="errorUpload"
             :on-success='successUpload' :max-size='512000'>
              <Button icon="ios-cloud-upload-outline">上传文件</Button>
            </Upload>
          </FormItem>
      </Form>
    </wsModal>
  </div>
</template>

<script>
import modal from '../../modal/'
import Util from '../../../lib/util.js'
import dataUtils from '../../../lib/dataUtils.js'
export default {
  components: {
    modal
  },
  props: {
    //
    // attachType: {
    //   type: Number,
    //   default: 0
    // },
    // 是否展示操作列
    showOperate: {
      type: Boolean,
      default: false
    },
    // 项目id 附件管理界面会用到
    projectId: {
      type: Number,
      default: 0
    },
    // 是否是附件管理界面
    fileManager: {
      type: Boolean,
      default: false
    },
    // 用来获取类别的key值
    typeArrayKey: {
      type: String,
      default: ''
    },
    // 默认选中的类型
    typeArray: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 传入的文件信息
    fileData: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: function() {
        return '上传附件'
      }
    },
    proData: Object,
    // 非文件管理界面会用到，用来区分类型
    // referType: {
    //   type: String,
    //   default: ''
    // }
    projectTypeArray:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectTypeArrays: this.projectTypeArray + '',
      upDownPic: Util.baseURL() + this.api.imgsPath,
      fileName: '?fileName=',
      table: {
        columns: [
          {
            title: '大类别',
            key: 'attachTypeName',
            render: (h, params) => {
              return h('div',
                params.row.attachTypeName ? params.row.attachTypeName : '-'
              )
            }
          },
          {
            title: '小类别',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map(item => {
                  return h('li', {
                  }, item.attachTypeName ? item.attachTypeName : '-')
                }) : '')
              ])
            }
          },
          {
            title: '格式',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map(item => {
                  return h('li', {
                  }, item.attachTitle.split('.')[item.attachTitle.split('.').length - 1])
                }) : '')
              ])
            }
          },
          {
            title: '容量',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map(item => {
                  return h('li', {
                  }, item.attachSize ? this.unitConversion(item.attachSize) : '-')
                }) : '')
              ])
            }
          },
          {
            title: '附注',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map(item => {
                  return h('li', {
                  }, item.attachRemark ? item.attachRemark : '-')
                }) : '')
              ])
            }
          },
          {
            title: '上传人',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map(item => {
                  return h('li', {
                  }, item.creatorName ? item.creatorName : '-')
                }) : '')
              ])
            }
          },
          {
            title: '操作',
            align: 'center',
            key: 'list',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subColCenter'
                }
              }, [
                h('ul', this.fileData[params.index].list.length > 0 ? this.fileData[params.index].list.map((item, itemIndex) => {
                  return h('li', {
                  }, [
                    h('Button', {
                      props: {
                        type: 'error',
                        size: 'small',
                        class: 'button'
                      },
                      style: {
                        marginRight: '5px',
                        display: this.fileManager || !this.showOperate || !item.attachSize || !this.hasFile(this.fileData[params.index].list[itemIndex].attachType) ? 'none' : 'inline-block'
                      },
                      on: {
                        click: () => {
                          this.delete(params.index, item, itemIndex)
                        }
                      }
                    }, '删除'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        class: 'button'
                      },
                      style: {
                        marginRight: '5px',
                        display: this.fileManager || !this.showOperate || !this.hasFile(this.fileData[params.index].list[itemIndex].attachType) ? 'none' : 'inline-block'
                      },
                      on: {
                        click: () => {
                          this.showUploadModel(params.index, item, itemIndex)
                        }
                      }
                    }, '上传'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        class: 'button'
                      },
                      style: {
                        marginRight: '5px',
                        display: !this.fileManager || !item.attachSize || this.proData.status < 13 ? 'none' : 'inline-block'
                      },
                      on: {
                        click: () => {
                          this.copyUrl(params.index, item, itemIndex)
                        }
                      }
                    }, '复制链接'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        class: 'button'
                      },
                      style: {
                        marginRight: '5px',
                        display: !item.attachSize ? 'none' : 'inline-block'
                      },
                      on: {
                        click: () => {
                          this.downLoad(params.index, item, itemIndex)
                        }
                      }
                    }, '下载')
                  ])
                }) : '')
              ])
            }
          }
        ],
        refreshTable: false
      },
      reportData: null,
      fields: {
        typeArrays: []
      },
      upload: {
        show: false,
        item: null,
        sequence: '',
        accept: '',
        uploadformat: [],
        form: {
          attachTypeParentName: '',
          attachTypeParentId: '',
          attachRemark: '',
          typeArray: [],
          attachTypeId: '',
          attachTypeName: ''
        },
        editIndex: -1,
        itemIndex: -1,
        attachType: '',
        referType: '',
        validate: {
          typeArray: [{ required: true, message: '请选择类别' }],
          attachRemark: [{ required: false, message: '请选择附注' }]
        }
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
  },
  methods: {
    init() {
      this.getTypeArrays(this.projectTypeArrays)
      if (this.fileManager) {
        this.getReportData()
      }
    },
    getTypeArraysIndex(disabled, idArray) {
      for (let index = 0; index < this.fields.typeArrays.length; index++) {
        const typeArraysItem = this.fields.typeArrays[index]
        if (typeArraysItem.value == idArray[0]) {
          for (let i = 0; i < typeArraysItem.children.length; i++) {
            const element = typeArraysItem.children[i]
            if (element.value == idArray[1]) {
              this.typeArraysDisable(disabled, [index, i])
              return
            }
          }
        }
      }
    },
    typeArraysDisable(disabled, indexArray) {
      this.fields.typeArrays[indexArray[0]].children[indexArray[1]].disabled = disabled
    },
    initTypeArrayDisable() {
      if (this.fileManager || this.fileData.length == 0) {
        return
      }
      if (this.fields.typeArrays[0].value == this.fileData[0].attachTypeId) {
        for (let index = 0; index < this.fields.typeArrays[0].children.length; index++) {
          const typeArraysItem = this.fields.typeArrays[0].children[index]
          for (let i = 0; i < this.fileData[0].list.length; i++) {
            const fileDataItem = this.fileData[0].list[i]
            if (fileDataItem.attachTypeId == typeArraysItem.value) {
              this.typeArraysDisable(true, [0, index])
            }
          }
        }
      }
    },
    hasFileDisable(files) {
      this.fileData = files
      this.initTypeArrayDisable()
    },
    // 获取类别列表
    getTypeArrays(type) {
      if (!this.typeArrayKey) {
        return
      }
      if(type){
        this.projectTypeArrays = type
      }else {
        this.projectTypeArrays = ''
      }
      var url = this.fileManager ? this.api.findTreeByCode : this.api.findTreeByCodeHasParent
      this.axios.post(url, { 'dictCode': this.typeArrayKey, projectType: this.projectTypeArrays }).then(response => {
        const res = response.data
        if (res.meta.code === 0) {
          this.fields.typeArrays = res.data
          this.initTypeArrayDisable()
          if(this.typeArray) {
            this.upload.form.typeArray = this.typeArray
            let selectedData = [];
            selectedData.push(this.fields.typeArrays[0])
            selectedData.push(this.fields.typeArrays[0].children[2])
            this.typeArraysChange(this.typeArray, selectedData)
          }
        } else {
          const message_ = res.meta.message
          this.$Message.warning('操作失败:' + message_)
        }
      })
    },
    hasFile(attachType){
          let hasFile = false
      if(this.fields.typeArrays && this.fields.typeArrays.length > 0) {
        if(this.fields.typeArrays[0].children && this.fields.typeArrays[0].children.length > 0){
          this.fields.typeArrays[0].children.forEach(item => {
            if(item.attachTwo == attachType){
              hasFile = true
            }
          })
        }
      }
      return hasFile
    },
    delete(index, item, itemIndex) {
      const _this = this
      this.$confirm({
        title: '操作提示',
        width: 450,
        content: '您确认删除吗?',
        onOk: function() {
          _this.axios.delete(_this.api.delFile + _this.fileData[index].list[itemIndex].attachId).then(response => {
            const res = response.data
            if (res.meta.code === 0) {
              _this.deleteItem(index, item, itemIndex)
            } else {
              const message_ = res.meta.message
              _this.$Message.warning('操作失败:' + message_)
            }
          })
        }
      })
    },
    deleteItem(index, item, itemIndex) {
      this.getTypeArraysIndex(false, [this.fileData[index].attachTypeId, this.fileData[index].list[itemIndex].attachTypeId])
      this.fileData[index].list.splice(itemIndex, 1)
      if (this.fileData[index].list.length == 0) {
        this.fileData.splice(index, 1)
      }
    },
    // 新增，编辑附件
    showUploadModel(index, item, itemIndex) {
      this.upload.editIndex = index
      if (index != -1) {
        this.upload.itemIndex = itemIndex
        this.upload.item = item
        this.upload.form = item
        this.upload.referType = item.referType
        this.upload.attachType = item.attachType
        this.upload.form.attachTypeParentName = this.fileData[index].attachTypeName
        this.upload.form.attachTypeParentId = this.fileData[index].attachTypeId
        this.upload.form.typeArray = [this.fileData[index].attachTypeId, this.fileData[index].list[itemIndex].attachTypeId]
        this.getTypeArraysIndex(false, this.upload.form.typeArray)
        this.fields.typeArrays.forEach(typeArraysItem => {
          if (typeArraysItem.value == this.fileData[index].attachTypeId) {
            typeArraysItem.children.forEach(childrenItem => {
              if (childrenItem.value == this.fileData[index].list[itemIndex].attachTypeId) {
                this.upload.sequence = childrenItem.sequence
              }
            })
          }
        })
        this.FileRename()
        this.uploadFormat()
      }
      this.upload.show = true
    },
    // 点击保存
    okUploadModel() {
      this.$refs['uploadModelForm'].validate((valid) => {
        if (valid) {

        }
      })
    },
    addFile(response) {
      var mergeItem = {}
      Object.assign(mergeItem, response.data, {
        attachTypeParentName: this.upload.form.attachTypeParentName,
        attachTypeParentId: this.upload.form.attachTypeParentId,
        // attachSuffix: this.unitConversion(response.data.attachSize),
        attachRemark: this.upload.form.attachRemark,
        attachTypeName: this.upload.form.attachTypeName,
        attachTypeId: this.upload.form.attachTypeId,
        referType: this.upload.referType,
        attachType: this.upload.attachType
      })
      this.fileData.push({
        attachTypeName: this.upload.form.attachTypeParentName,
        attachTypeId: this.upload.form.attachTypeParentId,
        list: [mergeItem]
      })
    },
    cancelModel() {
      if (this.upload.editIndex != -1) {
        this.getTypeArraysIndex(true, this.upload.form.typeArray)
      }
      this.cancelUploadModel()
    },
    // 关闭弹窗
    cancelUploadModel() {
      this.upload.editIndex = -1
      this.upload.itemIndex = -1
      this.upload.item = null
      this.upload.sequence = null
      this.fileName = '?fileName='
      this.upload.form = {
        attachTypeParentName: '',
        attachTypeParentId: '',
        // attachClassify: '',
        // attachClassifyName: '',
        attachRemark: '',
        typeArray: [],
        // attachSuffix: '',
        attachTypeId: '',
        attachTypeName: ''
      }
      this.$nextTick(() => {
        this.$refs['uploadModelForm'].resetFields()
      })
      this.upload.show = false
    },
    // 类別改变的回调方法
    typeArraysChange(value, selectedData) {
      // 小类别的名称
      this.upload.form.attachTypeParentId = selectedData[0].value
      this.upload.form.attachTypeParentName = selectedData[0].label
      this.upload.sequence = selectedData[selectedData.length - 1].sequence
      this.upload.form.attachTypeName = selectedData[selectedData.length - 1].label
      this.upload.form.attachTypeId = selectedData[selectedData.length - 1].value
      this.upload.referType = selectedData[selectedData.length - 1].attachOne
      this.upload.attachType = selectedData[selectedData.length - 1].attachTwo
      this.fileName = '?fileName='
      this.FileRename()
      this.uploadFormat()
    },
    // 上传前的逻辑，返回false可取消
    handleUpload() {
      this.$refs['uploadModelForm'].validate((valid) => {})
      if (this.upload.form.typeArray.length == 0) {
        this.$Message.warning('请上上传附件')
        return false
      }
      return true
    },
    // 文件上传失败
    errorUpload() {
      this.$Message.warning('文件上传失败')
    },
    // 文件格式校验失败
    formatError() {
      this.$Message.warning('文件格式验证失败')
    },
    // 文件大小超出限制
    exceededSize() {
      this.$Message.warning('文件过大')
    },
    // 上传成功
    successUpload(response, file, fileList) {
      if (response.meta.code != 0) {
        return
      }
      this.table.refreshTable = true
      this.$Message.success('上传成功')
      if (this.upload.editIndex != -1) {
        var mergeItem = {}
        Object.assign(mergeItem, response.data)
        mergeItem.attachTypeParentName = this.upload.form.attachTypeParentName
        mergeItem.attachTypeParentId = this.upload.form.attachTypeParentId
        mergeItem.attachRemark = this.upload.form.attachRemark
        mergeItem.attachTypeName = this.upload.form.attachTypeName
        mergeItem.attachTypeId = this.upload.form.attachTypeId
        mergeItem.referType = this.upload.referType
        mergeItem.attachType = this.upload.attachType
        this.fileData[this.upload.editIndex].list[this.upload.itemIndex] = mergeItem
      } else {
        var add = true
        // 新增
        this.fileData.forEach((item, index) => {
          // 新增小类
          if (this.upload.form.attachTypeParentId == item.attachTypeId) {
            var mergeItem = {}
            Object.assign(mergeItem, response.data, {
              attachTypeParentName: this.upload.form.attachTypeParentName,
              attachTypeParentId: this.upload.form.attachTypeParentId,
              // attachSuffix: this.unitConversion(response.data.attachSize),
              attachRemark: this.upload.form.attachRemark,
              attachTypeName: this.upload.form.attachTypeName,
              attachTypeId: this.upload.form.attachTypeId,
              referType: this.upload.referType,
              attachType: this.upload.attachType
            })
            item.list.push(mergeItem)
            add = false
          }
        })
        if (add) {
          this.addFile(response)
        }
      }
      setTimeout(() => {
        this.table.refreshTable = false
      }, 1)
      this.getTypeArraysIndex(true, this.upload.form.typeArray)
      this.cancelUploadModel()
      this.$emit('successUpload',this.fileData)
    },
    // 重命名上传文件
    FileRename() {
      if (this.upload.form.attachTypeParentName && this.upload.form.attachTypeName) {
        this.fileName = this.fileName.concat(this.upload.sequence.concat('_')).concat(this.upload.form.attachTypeParentName.concat('_')).concat(this.upload.form.attachTypeName).concat('_')
      }
    },
    // 控制文件上传类型
    uploadFormat() {
      this.upload.accept = dataUtils.fileTypes(this.upload.sequence)
      var format = this.upload.accept
      format = format.replace(/,/g, '')
      this.upload.uploadformat = format.split('.')
    },
    // 复制地址
    copyUrl(index, item, itemIndex) {
      var fileUrl = Util.fileURL.fileURL + decodeURI(item.accessPath).replace(new RegExp('/', 'gm'), '\\')
      // file://172.16.1.106/
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', fileUrl)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input)
      this.$Message.success('复制成功')
    },
    // 下载文件
    downLoad(index, item, itemIndex) {
      window.open(Util.resourceURL.resourceURL + item.accessPath)
    },
    // 容量单位换算
    unitConversion(attachSize) {
      if (attachSize >= 1048576) {
        return (attachSize / 1024 / 1024).toFixed(2) + 'Mb'
      } else {
        return Math.round(attachSize / 1024) + 'kb'
      }
    },
    // 获取合同信息
    getReportData() {
      this.axios.get('ws/biz/bizReport/findByProjectId/' + this.proData.id).then(response => {
        const res = response.data
        if (res.meta.code === 0) {
          this.reportData = res.data
        }
      })
    }
  }
}
</script>

<style>
.subCol >ul>li{
      /* margin:0 -18px; */
      list-style:none;
      text-align: left;
      height: 44px;
      padding: 8px;
      border-bottom:1px solid #ccc;
      overflow-x: hidden;

}
.subColCenter >ul>li{
      /* margin:0 -18px; */
      list-style:none;
      text-align: center;
      height: 44px;
      padding: 8px;
      border-bottom:1px solid #ccc;
      overflow-x: hidden;
}

.file .ivu-table-cell {
    padding-left: 0px;
    padding-right: 0px;
}

.file .ivu-table-cell span {
  margin-left: 10px;
}

.file .subColCenter .ivu-btn-small span {
  margin-left: 0px;
}

.subColCenter ul li:last-child{
  border-bottom: none
}
.subCol ul li:last-child{
  border-bottom: none
}
</style>

<style lang="stylus" scoped>

.add {
  margin-bottom: 10px;
}
.file {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/file/src/file.vue